import { ProposalInterfaces } from "../interfaces";
import BaseApi from "./BaseApi";

const baseUrl = 'api/proposal/';

class ProposalService {

    public postOpportunityForm(request: any): Promise<any> {
        const url = `${baseUrl}opportunity-form`;
        return BaseApi.post(url, request);
    }

    public postInvoiceReadingIA(request: any, config: any = {}): Promise<any> {
        const url = `${baseUrl}InvoiceReadingIA`;

        return BaseApi.post(url, request, {
            headers: {
                'Accept': 'application/json'
            },
            ...config
        });
    }
    public postOpportunityFormSimplified(request: any): Promise<any> {
        return BaseApi.post(`${baseUrl}opportunity-form-simplified`, request);
    }

    static postOpportunitySimulate(request: any): Promise<any> {
        return BaseApi.post(`${baseUrl}simulate`, request);
    }

    static postDiscountDefault(request: FormData): Promise<any> {
        return BaseApi.post(`${baseUrl}discount/default`, request);
    }

    static putOpportunity(request: any): Promise<any> {
        return BaseApi.put(`${baseUrl}opportunity-form`, request);
    }

    static patchHotLead(request: any): Promise<any> {
        return BaseApi.patch(`${baseUrl}hotlead`, request);
    }

    static async getSellType(): Promise<any[]> {
        return BaseApi.get(`${baseUrl}sell-type`);
    }

    static async getSupplyVoltage(): Promise<any[]> {
        return BaseApi.get(`${baseUrl}supply-voltage`);
    }
    static async getStructureType(): Promise<any[]> {
        return BaseApi.get(`${baseUrl}structure-type`);
    }
    static async getConnectionType(): Promise<any[]> {
        return BaseApi.get(`${baseUrl}connection-type`);
    }

    static async getGrupUnit(proposalTypeId:number): Promise<any[]> {
        return BaseApi.get(`${baseUrl}group-unit/${proposalTypeId}`);
    }
    static async getSpecialSituation(): Promise<any[]> {
        return BaseApi.get(`${baseUrl}special-situation`);
    }
    static getOpportunityForm(id: string) {
        return BaseApi.get(`${baseUrl}${id}/opportunity-form`);
    }

    static getProjects(id: string) {
        return BaseApi.get(`${baseUrl}${id}/Project`);
    }

    static getToEdit(id: string): Promise<any> {
        return BaseApi.get(`${baseUrl}${id}/edit`);
    }

    static postProposalContract(request: any): Promise<any> {
        return BaseApi.post(`${baseUrl}ProposalContract`, request);
    }
    static postProposalReview(request: any): Promise<any> {
        return BaseApi.post(`${baseUrl}ProposalReview`, request);
    }

    static postProposalreadquacao(id: string): Promise<any> {
        return BaseApi.post(`${baseUrl}${id}/ProposalReadquacao`);
    }
    static postProposalreadquacaoFinalizada(id: string): Promise<any> {
        return BaseApi.post(`${baseUrl}${id}/ProposalReadquacaoFinalizada`);
    }

    static postProposalTechnicalAlanalysisInviavel(id: any): Promise<any> {
        return BaseApi.post(`${baseUrl}${id}/technicalanalysisInviavel`);
    }

    static postProposalTechnicalAlanalysisParcialmenteInviavel(id: any): Promise<any> {
        return BaseApi.post(`${baseUrl}${id}/technicalanalysisParcialmenteInviavel`);
    }
    static postProposalTechnicalAlanalysisRecusadol(id: any): Promise<any> {
        return BaseApi.post(`${baseUrl}${id}/technicalanalysisRecusado`);
    }
    static postProposalTechnicalAlanalysisAceito(id: any): Promise<any> {
        return BaseApi.post(`${baseUrl}${id}/technicalanalysisAceito`);
    }
    static getDistributorList(): Promise<any> {
        return BaseApi.get(`${baseUrl}Distributors/List`);
    }

    static getProposalType(): Promise<ProposalInterfaces.IProposalType[]> {
        return BaseApi.get(`${baseUrl}proposaltype`);
    }
    static ListFormProposal(): Promise<ProposalInterfaces.IProposalType[]> {
        return BaseApi.get(`${baseUrl}ListFormProposal`);
    }

    static getProposalFromByType(id: number): Promise<any> {
        return BaseApi.get(`${baseUrl}proposalForm/${id}`);
    }
    static getProposalTypeById(id: number): Promise<any> {
        return BaseApi.get(`${baseUrl}proposaltype/${id}`);
    }

    static getSalesSumary(): Promise<ProposalInterfaces.IProposalCharts> {
        return BaseApi.get(`${baseUrl}salesSummary`);
    }
    static getStatusProposalStatusByType(id: number): Promise<ProposalInterfaces.IGetStatusProposalStatusByType> {
        return BaseApi.get(`${baseUrl}proposalStatusByType/${id}`);
    }

    static getProposalStatusAndType(
        idType: number,
        idStatus: number,
        name: string | null,
        document: string | null,
        dateInit: string | null,
        dateEnd: string | null,
        subStatus: string | null,
        proposalNumber: string | null,
        search: string | null,
    ): Promise<any> {
        return BaseApi.post(`${baseUrl}proposalStatusAndType/${idType}/${idStatus}`,
            { name, document, dateInit, dateEnd, subStatus, proposalNumber, search });
    }

    static getProposalStatusAndTypeNew(
        idType: number,
        idStatus: number,
        name: string | null,
        document: string | null,
        dateInit: string | null,
        dateEnd: string | null,
        subStatus: number | null,
        proposalNumber: string | null,
        search: string | null,
        pageNumber: number = 1,
    ): Promise<any> {
        return BaseApi.post(`${baseUrl}proposalStatusAndType/${idType}/${idStatus}/new`,
            { name, document, dateInit, dateEnd, subStatus, proposalNumber, search, pageNumber });
    }

    static getProposalDetail(idProposal: string): Promise<any> {
        const endpoint = idProposal.includes("P-")
            ? 'proposalDetailByNumber'
            : 'proposalDetail';

        return BaseApi.get(`${baseUrl}${endpoint}/${idProposal}`);
    }
    static getProposalUrlLinkPayment(idProposal: StringConstructor): Promise<any> {
        return BaseApi.get(`${baseUrl}proposalUrlPayment/${idProposal}`);
    }
    static SaveAdditionalInformationFiles(request: any): Promise<any> {
        return BaseApi.post(`${baseUrl}AdditionalInfoFile`, request);
    }

    static getReportMonthlyEarnings(): Promise<ProposalInterfaces.ReportMonthlyEarnings[]> {
        return BaseApi.get(`${baseUrl}report/monthly-earnings`);
    }

    static getEarningPotentialInMonth(): Promise<ProposalInterfaces.ReportMonthlyEarnings[]> {
        return BaseApi.get(`${baseUrl}earning-potential-in-month`);
    }
    static async GetProposalClosed(date?: Date): Promise<number> {
        return await BaseApi.get(`${baseUrl}proposalsClosedQty`, { params: { date } });
    }

    static GetkitsForUpdate(proposal: any): Promise<any> {
        return BaseApi.post(`${baseUrl}GetkitsForUpdate`, proposal);
    }
    static UpdateProposalKit(request: any): Promise<any> {
        return BaseApi.post(`${baseUrl}UpdateProposalKit`, request);
    }
    static getProposalPending(id: string): Promise<any> {
        return BaseApi.get(`${baseUrl}proposalPending/${id}`);
    }
    public postSavePendingFile(request: any): Promise<any> {
        const url = `${baseUrl}SavePendingFile`;
        return BaseApi.post(url, request, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json',
                'Access-Control-Allow-Origin': '*'
            },
        });
    }
    public SaveProposalPendingSave(request: any): Promise<any> {
        return BaseApi.put(`${baseUrl}ProposalPendingSave`, request);
    }

    static GetProposalWithoutLead(leadId: string): Promise<Array<{ id: string; clientName: string; proposalNumber: string }>> {
        return BaseApi.get(`${baseUrl}proposalWithoutLead`, { params: { leadId } });
    }

    static PutRelationshipLead(proposalId: string, leadId: string): Promise<void> {
        const senderData = new FormData();
        senderData.append('LeadId', leadId);
        return BaseApi.put(`${baseUrl}${proposalId}/relationship-lead`, senderData);
    }

    public UpdateDataHoraAgendarProposal(request: any): Promise<any> {
        return BaseApi.put(`${baseUrl}DataHoraAgendarProposal`, request);
    }
    public UpdateProposalStatusNegociation(id: any): Promise<any> {
        return BaseApi.put(`${baseUrl}ProposalStatusNegociation/${id}`);
    }

    static getProposalOptionsPaymentAll(id: string): Promise<any> {
        return BaseApi.get(`${baseUrl}ProposalOptionsPaymentAll/${id}`);
    }
    static getAcceptedTerm(id: number): Promise<any> {
        return BaseApi.get(`${baseUrl}documentAgreementSignature/${id}`);
    }
    static setAcceptedTerm(request: any): Promise<any> {
        return BaseApi.post(`${baseUrl}agreementSignature`, request);
    }
    static SaveAdditionalFilesRecharge(request: any): Promise<any> {
        return BaseApi.post(`${baseUrl}AddionalFilesRecharge`, request);
    }
}

export default ProposalService;